import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('marketingManagementStore')
@observer
class marketingGroupManagement extends Component {
  render() {
    const { marketingManagementStore, location } = this.props
    const { isFetching } = marketingManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default marketingGroupManagement;
